import * as numeral from 'numeral';
import 'numeral/locales/pt-br';
import * as moment from 'moment';
import { MyDatePicker } from 'src/app/dashboard/models/my-date-picker.interface';

export function trimTime(time: string): string {
  if (time) {
    const segmentedValue = time.split(':');

    if (segmentedValue[0] === '0' || segmentedValue[0] === '00') {
      segmentedValue.shift();

      return segmentedValue.join(':');
    } else {
      return segmentedValue.join(':');
    }
  }
}

export function numberToTime(value: number): string {
  return trimTime(numeral(value * 60).format('00:00:00'));
}

export function timeInMinutes(time: string): number {
  return moment.duration(time).asMinutes();
}

export function timeAgoInWords(dateTime: string) {
  return moment(dateTime, 'DD/MM/YYYY - HH:mm').fromNow();
}

export function dateCurrent() {
  return moment().format('L');
}

export function longDateCurrent() {
  return moment().format('LL');
}

export function timeCurrent() {
  return moment().format('LTS');
}

export function dateTimeCurrent() {
  return moment().format('DD/MM/YYYY - HH:mm:ss');
}

export function myDatePickerCurrentDate() {
  const day: string = moment().format('DD');
  const month: string = moment().format('MM');
  const year: string = moment().format('YYYY');

  return {
    date: { year: year, month: parseInt(month), day: parseInt(day) },
    formatted: `${ day }/${ month }/${ year }`
  };
}

export function myDatePickerDate(date: string) {
  const day: string = date.substring(0, 2);
  const month: string = date.substring(3, 5);
  const year: string = date.substring(6, 10);

  return {
    date: { year: year, month: parseInt(month), day: parseInt(day) },
    formatted: `${ day }/${ month }/${ year }`
  };
}
